import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { clearCompletedDraft } from "./draftPersistence";

const PUBLIC_LINKS = [
  { label: "Homeroom", to: "/" },
  { label: "Ask Miss Paw-some", to: "/ask" },
  { label: "Gifts", to: "/gifts" },
  { label: "Coming Soon", to: "/coming-soon" },
  { label: "Order", to: "/order?new=1" },
];

const DESKTOP_LINKS = [
  { label: "Homeroom", to: "/" },
  { label: "Ask Miss Paw-some", to: "/ask" },
  { label: "Gifts", to: "/gifts" },
  { label: "Coming Soon", to: "/coming-soon" },
  { label: "Order", to: "/order?new=1" },
  { label: "Admin", to: "/admin" },
];

export const PublicTopNav = ({ overlay = false }) => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const startNewOrder = (link) => {
    if (link.label === "Order" && location.pathname !== "/order") clearCompletedDraft();
  };

  return (
    <nav
      className={`${overlay ? "absolute top-0 z-30 md:left-1/2 md:w-screen md:-translate-x-1/2" : "relative z-30"} h-[58px] bg-[#173E72] md:h-[72px] md:bg-[#173E72]`}
      aria-label="Main navigation"
      data-testid="public-top-navigation"
    >
      <div
        className="mx-auto flex h-full w-[1366px] max-w-full items-center justify-end px-4 text-[#34465E] md:justify-between md:gap-8 md:px-12 md:text-[20px] md:text-[#F8F2E6]"
        style={{ fontFamily: '\"Roboto Slab\", serif' }}
      >
        <Link to="/" className="hidden shrink-0 text-[#F8F2E6] md:block" aria-label="Paw-some Reports home">
          <span className="relative inline-block text-center font-bold leading-[0.9] tracking-tight">
            <span className="block text-[28px]">Paw-some<sup className="ml-0.5 align-super text-[7px]">TM</sup></span>
            <span className="mt-1 block text-[13px] tracking-[0.32em]">REPORTS</span>
          </span>
        </Link>

        <div className="hidden items-center gap-8 md:flex">
          {DESKTOP_LINKS.map((link) => (
            <Link key={link.to} to={link.to} onClick={() => startNewOrder(link)} className="whitespace-nowrap text-[#F8F2E6] hover:text-white">
              {link.label}
            </Link>
          ))}
        </div>

        <button
          type="button"
          className="flex h-11 w-11 items-center justify-center rounded-lg bg-[#F7F3EA] text-[32px] leading-none text-[#173E72] md:hidden"
          aria-label={mobileOpen ? "Close menu" : "Open menu"}
          aria-expanded={mobileOpen}
          onClick={() => setMobileOpen((open) => !open)}
          data-testid="mobile-menu-button"
        >
          {mobileOpen ? "×" : "☰"}
        </button>
      </div>

      {mobileOpen && (
        <div
          className="absolute left-0 right-0 top-[58px] z-50 border-t border-[#DCCDB4] bg-[#F7F3EA] px-6 py-3 shadow-lg md:hidden"
          data-testid="mobile-menu"
          style={{ fontFamily: "Georgia, serif" }}
        >
          {PUBLIC_LINKS.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              onClick={() => { startNewOrder(link); setMobileOpen(false); }}
              className="block border-b border-[#DCCDB4] py-4 text-[20px] text-[#34465E] last:border-b-0 hover:text-[#173E72]"
            >
              {link.label}
            </Link>
          ))}
        </div>
      )}
    </nav>
  );
};

export default PublicTopNav;
